<template>
<md-dialog :md-active.sync="active" :md-close-on-esc="false"
:md-click-outside-to-close="false">
<md-dialog-title>{{ i18n.lbl_sub() }} - {{ form.desc }}</md-dialog-title>
<div class="create-subwallet">
<select-field :label="i18n.lbl_asset()" v-model="form.asset" :values="Object.keys(accountBalances)"></select-field>
<input-field2 :sec-label="i18n.lbl_new_dir()" :label="i18n.lbl_direction()" v-model.trim="form.desc" :list="descriptions"/>
<input-field2 :sec-label="i18n.lbl_new_client()" :label="i18n.lbl_client()" v-model.trim="form.client" :list="clients"/>
</div>
<md-dialog-actions>
    <md-button class="md-button btn md-primary md-theme-default" @click="close" :disabled="isLoading">{{ i18n.lbl_cancel() }}</md-button>
    <md-button class="md-button btn md-primary md-theme-default" @click="createWallet" :disabled="isLoading">{{ i18n.  lbl_create_wallet() }}</md-button>
</md-dialog-actions>
</md-dialog>
</template>

<script>
import { i18n } from '@js/i18n'
import SelectField from '@com/fields/SelectField'
import InputField2 from '@com/fields/InputField2'
import { vuexTypes } from '@vuex/types'
import { mapGetters } from 'vuex'
export default {
  name: 'AddSubwalletModal',
  components: { SelectField, InputField2 },
  emits: ['close', 'create'],
  props: {
    active: {
      type: Boolean,
      default: false
    },
    values: {
      type: Array,
      required: true
    },
    currentAsset: {
      type: String,
      required: true
    },
    descriptions: {
      type: Array,
      required: true
    },
    clients: {
      type: Array,
      required: true
    },
    mains: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      i18n,
      isLoading: false,
      form: {
        desc: '',
        asset: '',
        client: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      vuexTypes.accountBalances,
      vuexTypes.accountId
    ]),
    getDescs () {
      return this.values.map(el => el.Description)
    },
    mainsWalletsAssets () {
      if (this.mains.length) {
        return this.mains.map(wallet => wallet.Asset)
      }
      return []
    }
  },
  created () {
    this.form.asset = this.currentAsset
  },
  methods: {
    close () {
      this.$emit('close')
    },
    async createWallet () {
      if (!this.form.asset || !this.form.desc || !this.form.client) return
      this.isLoading = true
      if (!this.mainsWalletsAssets.includes(this.form.asset)) {
        await this.$emit('create', {
          user_id: this.accountId,
          asset: this.form.asset,
          description: 'main',
          client_name: 'main'
        })
      }
      await this.$emit('create', {
        user_id: this.accountId,
        asset: this.form.asset,
        description: this.form.desc,
        client_name: this.form.client
      })
      this.isLoading = false
      this.close()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/vue/app/dashboard/index/AddSubwalletModal.vue